var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"adContainer",staticClass:"ad-container"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.adurl,"frameborder":"0","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }